export const patientConnectUrl = {
    base: "https://app.longboat.com",
    rel: "/api/v1/HarmonyBiosciences/3/patient_connect",
    get absolutePath() {
        return this.base + this.rel;
    },
}

export const patientConnectHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    //'Authorization': '',
}

export const gMapConsentCookieKey = "gMapConsentCookie";
export const gMapConsentCookieExpiryTimeInMins = 10;
export const googleMapApiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || ''
export const googleMapUrl = `https://maps.googleapis.com/maps/api/js?key=${googleMapApiKey}`;

// Animation
export const isPageAnimationEnabled = true;

// Login Page Style
export const isDefaultStyle = true; // true or false

//Images
export const logoPath = "client_logo.png";

//Google Analytics
//Pendo Analytics
export const pendoKey = process.env.VUE_APP_PENDO_API_KEY;
export const studyURL = "tempo.longboat.com";
export const sponsorName = "Harmony-Biosciences";
export const studyId = "HARM493";
export const AppType = "PRW";
export const pendoAccountName = studyId + '_' + AppType;

// Authentication
export const cookieExpiryTimeInMins = 10;
export const passwords = [{
    key: "pass", // key used for storing this password in cookie
    value: String(process.env.VUE_APP_PASSWORD),  // password
    toRoute: "/", // go to this route/url after successful authentication
},];

// i18n localisation configuration
export const defaultLocale = "en";
export const supportedLocales = [
    "en",
    // "es"
];

// Google map study Sites
export let gMapOptions = {
    center: {
        lat: 33.9466277,
        lng: -84.3320862,
    },
    scrollwheel: false,
    zoom: 10,
    styles: [{
        "featureType": "all",
        "elementType": "geometry.fill",
        "stylers": [{
            "weight": "2.00"
        }]
    },
    {
        "featureType": "all",
        "elementType": "geometry.stroke",
        "stylers": [{
            "color": "#9c9c9c"
        }]
    },
    {
        "featureType": "all",
        "elementType": "labels.text",
        "stylers": [{
            "visibility": "on"
        }]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [{
            "color": "#f2f2f2"
        }]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [{
            "color": "#ffffff"
        }]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry.fill",
        "stylers": [{
            "color": "#ffffff"
        }]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [{
            "saturation": -100
        },
        {
            "lightness": 45
        }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [{
            "color": "#eeeeee"
        }]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#7b7b7b"
        }]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.stroke",
        "stylers": [{
            "color": "#ffffff"
        }]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [{
            "visibility": "simplified"
        }]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [{
            "color": "#46bcec"
        },
        {
            "visibility": "on"
        }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [{
            "color": "#c8d7d4"
        }]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#070707"
        }]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.stroke",
        "stylers": [{
            "color": "#ffffff"
        }]
    }
    ]
}
export let getSites = (googleMapObj, mapObj) => {
    let icon = {
        url: "/map.png",
    };
    let sites = [

        // New sites
        // new googleMapObj.maps.Marker({
        //     active: true,
        //     title: "CTI Clinical Research Center - PPDS",
        //     site_no: "312US-001",
        //     address: "1775 Lexington Ave, Cincinnati, Ohio, 45212, United States",
        //     email: "",
        //     position: {
        //         lat: 39.144857,
        //         lng: -84.469951,
        //     },
        //     icon: icon,
        //     map: mapObj,
        // }),

        new googleMapObj.maps.Marker({
            active: true,
            title: "Road Runner Research Ltd",
            site_no: "312US-002",
            address: "4374 Lockhill Selma Rd Ste 108, San Antonio, Texas, 78249-3539, United States",
            email: "",
            position: {
                lat: 29.5845,
                lng: -98.6011,
            },
            icon: icon,
            map: mapObj,
        }),

        new googleMapObj.maps.Marker({
            active: true,
            title: "Childrens Hospital of Wisconsin",
            site_no: "312US-003",
            address: "9200 W Wisconsin Ave, Milwaukee, Wisconsin, 53226-3522, United States",
            email: "",
            position: {
                lat: 43.0389,
                lng: -87.9065,
            },
            icon: icon,
            map: mapObj,
        }),

        new googleMapObj.maps.Marker({
            active: true,
            title: "Nemours Children Clinic Wilmington",
            site_no: "312US-004",
            address: "1600 Rockland Rd Dept of, Wilmington, Delaware, 19803-3607, United States",
            email: "",
            position: {
                lat: 39.7722,
                lng: -75.5340,
            },
            icon: icon,
            map: mapObj,
        }),

        new googleMapObj.maps.Marker({
            active: true,
            title: "Rady Childrens Hospital San Diego - PIN",
            site_no: "312US-005",
            address: "3030 Childrens Way, San Diego, California, 92123-4232, United States",
            email: "",
            position: {
                lat: 32.8068,
                lng: -117.1557,
            },
            icon: icon,
            map: mapObj,
        }),

        new googleMapObj.maps.Marker({
            active: true,
            title: "Ann & Robert H. Lurie Children's Hospital of Chicago",
            site_no: "312US-006",
            address: "225 E Chicago Ave, Chicago, Illinois, 60611-2991, United States",
            email: "",
            position: {
                lat: 41.8965,
                lng: -87.6205,
            },
            icon: icon,
            map: mapObj,
        }),

        new googleMapObj.maps.Marker({
            active: true,
            title: "Johns Hopkins University",
            site_no: "312US-007",
            address: "1800 Orleans St Sheikh Zayed Tower, Baltimore, Maryland, 21287, United States",
            email: "",
            position: {
                lat: 39.2965,
                lng: -76.5917,
            },
            icon: icon,
            map: mapObj,
        }),

        // new googleMapObj.maps.Marker({
        //     active: true,
        //     title: "Tri-Valley Sleep Center",
        //     site_no: "312US-008",
        //     address: "5201 Norris Canyon Rd, Suite 120, San Ramon, California, 94583-5410, United States",
        //     email: "",
        //     position: {
        //         lat: 37.7694,
        //         lng: -121.9617,
        //     },
        //     icon: icon,
        //     map: mapObj,
        // }),

     /*   new googleMapObj.maps.Marker({
            active: true,
            title: "Atlanta Diabetes Associates",
            site_no: "312US-009",
            address: "1800 Howell Mill Rd NW Ste 450, Atlanta, Georgia, 30318-2508, United States",
            email: "",
            position: {
                lat: 33.7946,
                lng: -84.4113,
            },
            icon: icon,
            map: mapObj,
        }),*/

        new googleMapObj.maps.Marker({
            active: true,
            title: "Santa Monica Clinical Trials",
            site_no: "312US-010",
            address: "1301 20th St Ste 370, Santa Monica, California, 90404-2087, United States",
            email: "",
            position: {
                lat: 34.0296,
                lng: -118.4846,
            },
            icon: icon,
            map: mapObj,
        }),

        new googleMapObj.maps.Marker({
            active: true,
            title: "Maimonides Medical Center-920 48th St",
            site_no: "312US-011",
            address: "920 48th St, Brooklyn, New York, 11219, United States",
            email: "",
            position: {
                lat: 40.6374,
                lng: -73.9952,
            },
            icon: icon,
            map: mapObj,
        }),

        new googleMapObj.maps.Marker({
            active: true,
            title: "Center of Excellence in Diabetes and Endocrinology",
            site_no: "312US-012",
            address: "3814 Auburn Blvd Ste 72, Sacramento, California, 95821-2123, United States",
            email: "",
            position: {
                lat: 38.6489,
                lng: -121.3755,
            },
            icon: icon,
            map: mapObj,
        }),

        /*new googleMapObj.maps.Marker({
            active: true,
            title: "Texas Valley Clinical Research, LLC",
            site_no: "312US-013",
            address: "1116 E 8th St Ste 4, Weslaco, Texas, 78596-7288, United States",
            email: "",
            position: {
                lat: 26.1595,
                lng: -97.9908,
            },
            icon: icon,
            map: mapObj,
        }),*/

        new googleMapObj.maps.Marker({
            active: true,
            title: "Texas Children's Hospital-6701 Fannin St",
            site_no: "312US-014",
            address: "6701 Fannin St Fl 9, Houston, Texas, 77030-2608, United States",
            email: "",
            position: {
                lat: 29.7094,
                lng: -95.4018,
            },
            icon: icon,
            map: mapObj,
        }),

        new googleMapObj.maps.Marker({
            active: true,
            title: "Emory University School of Medicine",
            site_no: "312US-015",
            address: "101 Woodruff Circle, Atlanta, Georgia, 30322-0001, United States",
            email: "",
            position: {
                lat: 33.7912,
                lng: -84.3237,
            },
            icon: icon,
            map: mapObj,
        }),

        // new googleMapObj.maps.Marker({ 
        //     active: true,
        //     title: "Rare Disease Research, LLC",
        //     site_no: "312US-016",
        //     address: "1891 Howell Mill Rd NW Ste B, Atlanta, Georgia, 30318-2512, United States",
        //     email: "",
        //     position: {
        //         lat: 33.8083,
        //         lng: -84.4196,
        //     },
        //     icon: icon,
        //     map: mapObj,
        // }),

        new googleMapObj.maps.Marker({
            active: true,
            title: "Childrens Hospital Colorado",
            site_no: "312US-017",
            address: "3123 East 16th Avenue, Aurora, Colorado, 80045, United States",
            email: "",
            position: {
                lat: 39.742043,
                lng: -104.841330,
            },
            icon: icon,
            map: mapObj,
        }),

        new googleMapObj.maps.Marker({
            active: true,
            title: "Montefiore Medical Center - 111 East 210th Street",
            site_no: "312US-018",
            address: "111 E 210th St, Bronx, New York, 10467-2401, United States",
            email: "",
            position: {
                lat: 40.8796,
                lng: -73.8804,
            },
            icon: icon,
            map: mapObj,
        }),

        new googleMapObj.maps.Marker({
            active: true,
            title: "Mayo Clinic - PPDS",
            site_no: "312US-019",
            address: "200 1st St SW, Rochester, Minnesota, 55905-0001, United States",
            email: "",
            position: {
                lat: 44.0221,
                lng: -92.4668,
            },
            icon: icon,
            map: mapObj,
        }),

        new googleMapObj.maps.Marker({
            active: true,
            title: "Center for Human Genetics",
            site_no: "312US-020",


            address: "11100 Euclid Ave, Cleveland, Ohio, 44106-1716, United States",
            email: "",
            position: {
                lat: 41.5046,
                lng: -81.6094,
            },
            icon: icon,
            map: mapObj,
        }),

       /* new googleMapObj.maps.Marker({
            active: true,
            title: "Nationwide Children's Hospital",
            site_no: "312US-021",
            address: "700 Childrens Dr, Columbus, Ohio, 43205-2664, United States",
            email: "",
            position: {
                lat: 39.9532,
                lng: -82.9812,
            },
            icon: icon,
            map: mapObj,
        }),*/
        new googleMapObj.maps.Marker({
            active: true,
            title: "Riley Children's Specialist Carmel",
            site_no: "312US-022",
            address: "705 Riley Hospital Drive ROC 4270, Indianapolis, 46202, United States",
            email: "",
            position: {
                lat: 39.9784,
                lng: -86.1180,
            },
            icon: icon,
            map: mapObj,
        }),

    ];
    return sites;
};

/* ================= Eligibility form  ===================== */
export const answers = {
    YES: "yes_a",
    NO: "no_a",
    MAYBE: "maybe_a",
    DONTKNOW: "dk_a",
};

export const eligibilityForm = (context) => [

    // Question 1
    {
        question: context.$t("question1"),
        field_name: context.$t("question1", 'en'),
        choices: [{
            value: answers.YES,
            text: context.$t("yes_a"),
            englishValue: context.$t("yes_a", 'en')
        },
        {
            value: answers.NO,
            text: context.$t("no_a"),
            englishValue: context.$t("no_a", 'en')
        },
        ],
        correctAnswers: [answers.YES],
    },

    // Question 2
    {
        question: context.$t("question2"),
        field_name: context.$t("question2", 'en'),
        choices: [{
            value: answers.YES,
            text: context.$t("yes_a"),
            englishValue: context.$t("yes_a", 'en')
        },
        {
            value: answers.NO,
            text: context.$t("no_a"),
            englishValue: context.$t("no_a", 'en')
        },
        {
            value: answers.DONTKNOW,
            text: context.$t("dk_a"),
            englishValue: context.$t("dk_a", 'en')
        },
        ],
        correctAnswers: [answers.YES, answers.DONTKNOW],
    },

    // Question 3
    {
        question: context.$t("question3"),
        field_name: context.$t("question3", 'en'),
        choices: [{
            value: answers.YES,
            text: context.$t("yes_a"),
            englishValue: context.$t("yes_a", 'en')
        },
        {
            value: answers.NO,
            text: context.$t("no_a"),
            englishValue: context.$t("no_a", 'en')
        },
        ],
        correctAnswers: [answers.NO],
    },

    // Question 4
    {
        question: context.$t("question4"),
        field_name: context.$t("question4", 'en'),
        choices: [{
            value: answers.YES,
            text: context.$t("yes_a"),
            englishValue: context.$t("yes_a", 'en')
        },
        {
            value: answers.NO,
            text: context.$t("no_a"),
            englishValue: context.$t("no_a", 'en')
        },
        {
            value: answers.DONTKNOW,
            text: context.$t("dk_a"),
            englishValue: context.$t("dk_a", 'en')
        },
        ],
        correctAnswers: [answers.NO, answers.DONTKNOW],
    },

    // Question 5
    {
        question: context.$t("question5"),
        field_name: context.$t("question5", 'en'),
        choices: [{
            value: answers.YES,
            text: context.$t("yes_a"),
            englishValue: context.$t("yes_a", 'en')
        },
        {
            value: answers.NO,
            text: context.$t("no_a"),
            englishValue: context.$t("no_a", 'en')
        },
        ],
        correctAnswers: [answers.NO],
    },

    // Question 6
    {
        question: context.$t("question6"),
        field_name: context.$t("question6", 'en'),
        choices: [{
            value: answers.YES,
            text: context.$t("yes_a"),
            englishValue: context.$t("yes_a", 'en')
        },
        {
            value: answers.NO,
            text: context.$t("no_a"),
            englishValue: context.$t("no_a", 'en')
        },
        {
            value: answers.DONTKNOW,
            text: context.$t("dk_a"),
            englishValue: context.$t("dk_a", 'en')
        },

        ],
        correctAnswers: [answers.NO, answers.DONTKNOW],
    },

    // Question 7
    {
        question: context.$t("question7"),
        field_name: context.$t("question7", 'en'),
        choices: [{
            value: answers.YES,
            text: context.$t("yes_a"),
            englishValue: context.$t("yes_a", 'en')
        },
        {
            value: answers.NO,
            text: context.$t("no_a"),
            englishValue: context.$t("no_a", 'en')
        },
        ],
        correctAnswers: [answers.NO],
    },
];


/* ================= Patient Connect Sites (Type One)  ===================== */
import ireland from "@/sites/ireland.js";
export const sites = [{
    id: "ie",
    name: "Ireland",
    states: ireland,
},
    /*
    {
        id: "us",
        name: "United States",
        states: usa,
    },
    */
];

/* ================= Patient Connect Sites (Type Two)  ===================== */
//import irelandTwo from "@/sites/irelandTwo.js";
import usTwo from "@/sites/usTwo.js";
export const sitesTwo = [
    /*
    {
        id: "ie",
        name: "Ireland",
        states: irelandTwo,
    }, */
    {
        id: "us",
        name: "United States",
        states: usTwo,
    },


];